export default __webpack_public_path__ + "static/media/about_me.2d60824f.jpeg";